import { useEffect, useRef, useState } from "react";

/** Sort menu open state + click-outside to close (desktop + mobile share `sortOpen`). */
export function useSearchSortDropdown() {
  const sortWrapRef = useRef<HTMLDivElement | null>(null);
  const [sortOpen, setSortOpen] = useState(false);

  useEffect(() => {
    if (!sortOpen) return;
    const onDown = (e: MouseEvent) => {
      const node = sortWrapRef.current;
      if (!node) return;
      if (!node.contains(e.target as Node)) setSortOpen(false);
    };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, [sortOpen]);

  return { sortOpen, setSortOpen, sortWrapRef };
}
